import {toAsterisk, toExpirationDate} from '@logistics-frontend/core/formatters'
import {flow, get, map, toLower} from '@logistics-frontend/utils'

import {CardSystem, KnownCardSystem, PaymentCard} from '../../../model/payment'
import {EmployeeCardToBoundListResponse, PaymentMethod} from '../../../repo/cargo-corp/types'

function isKnownCardSystem(x: string): x is KnownCardSystem {
  return ['visa', 'mastercard', 'mir', 'maestro'].includes(x)
}

const toSystem: (p: PaymentMethod) => CardSystem = flow(
  get('system'),
  toLower,
  function _toSystem(system?: string): CardSystem {
    if (system && isKnownCardSystem(system)) {
      return system
    }

    return 'unknown'
  },
)

function toCard(paymentMethod: PaymentMethod): PaymentCard {
  return {
    __type: 'card',
    id: 'card_id' in paymentMethod ? paymentMethod.card_id : paymentMethod.id,
    system: toSystem(paymentMethod),
    number: toAsterisk(paymentMethod.number),
    expirationDate: toExpirationDate(paymentMethod.expiration_year, paymentMethod.expiration_month),
  }
}

export const toCards: (response: EmployeeCardToBoundListResponse) => PaymentCard[] = flow(
  get('available_cards'),
  map(toCard),
)
